import { useMemo } from "react";
import useAuthStore from "./states/authStore";
import logo from "./assets/IQ_logo_dark.svg";
import CRMLogo from "./assets/icons/CRM_logo.svg";
import TicketsLogo from "./assets/icons/Tickets_logo.svg";
import AdminLogo from "./assets/icons/Admin_logo.svg";
import "./styles/Main.css";
import { NavBar, Page, PageHeader, PageHeaderProvider } from "@iq/models";
import { GoHome } from "react-icons/go";
import AppUserMenu from "./components/AppUserMenu";
import HeaderClockAction from "./components/HeaderClockAction";


function Main(){

    const profile = useAuthStore((state) => state.profile);

    const profileName = profile?.name ?? "User";
    const profileId = profile?.id ?? null;

    const appLinks = useMemo(() => ([
        { label: "CRM", image: CRMLogo, href: "/contacts", variant: "crm" },
        { label: "Tickets", image: TicketsLogo, href: "/IT", variant: "tickets" },
        { label: "Admin", image: AdminLogo, href: "/admin", variant: "admin" },
        { label: "Projects", image: AdminLogo, href: "/projects", variant: "projects" },
        { label: "Payment", image: AdminLogo, href: "/payment", variant: "payment" },
        { label: "Store", image: AdminLogo, href: "http://localhost:3008", variant: "store" },
    ]), []);

    return(
            <div className="crm-layout app">
                <div className="nav-section">
                    <NavBar
                        activePage="Home"
                        navItems={[]}
                        onPageChange={() => {}}
                        footerAction={{
                            label: "Home",
                            icon: <GoHome size={24} />,
                            active: true,
                            onClick: () => {},
                        }}
                    />
                </div>
                <PageHeaderProvider userMenu={(
                    
                    <>
                        <HeaderClockAction />
                        <AppUserMenu name={profileName} id={profileId} />
                    </>
                    
                )}>
                    <PageHeader title={<img src={logo} alt="IQ Logo" style={{ height: "var(--font-size-md)", marginTop: "var(--space-1)" }} />} />
                    <Page>
                        <div className="app-main-content">
                            <div className="main-panel-title-container">
                                <h2 className="main-panel-welcome">Welcome back,</h2>
                                <h2 className="main-panel-profile-name">{profileName}</h2>
                            </div>
                            <h2 className="main-panel-title">- Your Apps -</h2>
                            <div className="main-panel-grid">
                                {appLinks.map((app) => (
                                    <a
                                        key={app.label}
                                        href={app.href}
                                        className={`main-app-link main-app-link--${app.variant}`}
                                    >
                                        <img src={app.image} alt={app.label} className="main-app-link-image"/>
                                        <p className="main-app-link-text">{app.label}</p>
                                    </a>
                                ))}
                            </div>
                        </div>

                        <div className="main-panel-spacer" aria-hidden="true" />
                    </Page>
                </PageHeaderProvider>
            </div>
    )
}

export default Main